import { Loading } from '@/components/Layout/Loading';
import environment from '@/config/environment';
import serviceUrls from '@oncolens/oncolens-ui/lib/api/service-urls';
import React from 'react';

export default function Logout() {
  const currentBaseUrl = `${window.location.protocol}//${window.location.host}`;
  window.location.href = `${serviceUrls.AUTH.BASE()}/auth/logout?authZeroClientId=${environment.Auth0.clientId()}&returnUrl=${currentBaseUrl}/login`;
  return <Loading />;
}
